// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"81084319","767":"50ebf6a7"}[chunkId] + ".chunk.js";
};